// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

export const config: Config = {
  endpointAuthenticatorURL: window["env"]["endpointAuthenticatorURL"],
  browserChannelURL: window["env"]["browserChannelURL"],
  signalCollectorURL: window["env"]["signalCollectorURL"],
  securityMode: window["env"]["securityMode"], // "ENFORCED", "PERMISSIVE", "DISABLED"
};

interface Config {
  endpointAuthenticatorURL: string;
  browserChannelURL: string;
  signalCollectorURL: string;
  securityMode: string;
}
